const RepairFilePricingTypeConstant = {
  ESTIMATE: 'ESTIMATE',
  PACKAGE: 'PACKAGE',
  GUARANTEE: 'GUARANTEE'
}

export default RepairFilePricingTypeConstant;
